import React from 'react'
import Slider from '../slider/Slider'
import Card from '../card/Card'

import './bussines.css'

class BussinesDevelopment extends React.Component {
    render() {
        return (
            <div className="bussines">
                <Slider />
                <Card title="Nuestra Historia">
                Nuestra empresa fue creada en 1990 en el municipio de Rionegro - Antioquia con la pretención de fabricar productos y prestar sevicios relacionados con pisos, pero nuestro compromiso nos permitieron no sólo aumentar la variedad de baldosas y zócalos, sino también incluir la comercialización de lavaderos y bases en marmol. Pero todo no terminó con la ampliación de nuestro catálogo, ya que por nuestro interés de continuar creciendo y la demanda de productos y empresas como la nuestra, abrimos una sede en Santa Rosa de Cabal donde continuamos con nuestra política de calidad y excelente precio.
                </Card>
                <Card title="Obras ejecutadas">
                    <h3> Estos son algunos de nuestros trabajos</h3>
                    <div className="works">
                        <div className="work">
                            <h4>En Antioquia</h4>
                            <ul>
                                <li> Hogar Infantil, Los Lagos </li>
                                <li> Parque Educativo  San Vicente Ferrer </li>
                                <li> Casa Usuarios Campesinos, La Ceja</li>
                                <li> Corporación Semillas de Fe</li>
                                <li> Clínica Somer</li>
                                <li> Hospital San Juan de Dios</li>
                                <li> Escuela Baldomero Sanín Cano</li>
                                <li> Colegio La Industrial</li>
                                <li> COREDI, Rionegro</li>
                                <li> COREDI, Marinilla</li>
                                <li> Plaza de Mercado, El Peñol</li>
                                <li> Coliseo Cañas Gordas</li>
                                <li> Instituciones Educativas en Granada</li>
                                <li> Entre otros</li>
                            </ul>
                        </div>
                        <div className="work">
                            <h4>En Risaralda</h4>
                            <ul>
                                <li>Reconversión Ley – Éxito, Eje Cafetero</li>
                                <li>Baldosas del Norte Ltda</li>
                                <li>Consorcio Hospital Victoria</li>
                                <li>Entre otros</li>
                            </ul>
                        </div>
                    </div>
                </Card>
            </div >
        )
    }
}
export default BussinesDevelopment


// WEBPACK FOOTER //
// ./src/components/bussinesDevelopment/BussinesDevelopment.jsx